import React from 'react';
import AssessmentFilters from 'components/threepp/assessment/Filters/AssessmentFilters';
import { makeStyles, Paper } from '@material-ui/core';
import { useViewport } from 'utils/getViewport/getViewport';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '4rem'
  },
  stickySidebar: {
    position: 'sticky',
    top: '1rem',
    [theme.breakpoints.down(theme.breakpoints.values.mobile)]: {
      height: 'calc(100  * var(--vh) - 44px)',
      overflowY: 'scroll'
    }
  }
}));

export const Filters = ({ assessment }) => {
  const { isMobile } = useViewport();
  const classes = useStyles();
  return (
    <div className={!isMobile ? `sidebar-none col-right ${classes.root}` : ''}>
      <Paper className={classes.stickySidebar}>
        <AssessmentFilters assessment={assessment} />
      </Paper>
    </div>
  );
};
